import html from "../privacy-candidates.html?raw";
import scripts from "../scripts/terms-of-use.json";

import type { MirrorContent } from "../pages";

export const content: MirrorContent = { html, scripts };
export default content;
